const showOTherInputFieldsReducer = (state = false, action) => {
	switch(action.type){
	case 'SHOWOTHERTRUE':	
		return true;
	case 'SHOWOTHERFALSE':
		return false;
	default:
		return state;
	}
}

export default showOTherInputFieldsReducer;